var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isSplashActive)?_c('div',{staticClass:"video-container"},[_c('video',{attrs:{"src":require("@/assets/tvSplash.mp4"),"muted":"","autoplay":""},domProps:{"muted":true}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }